import { type ModalSize } from './types.js';

export const MODAL_SIZES: Record<
  Exclude<ModalSize, 'fullscreen' | 'fullWidth'>,
  number
> = {
  lg: 704,
  md: 544,
  xlarge: 968,
};
